"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[265],{

/***/ 91001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function Footer() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    sx: {
      color: "#ffffff",
      margin: "5rem 0 2rem"
    },
    variant: "body2",
    color: "text.secondary",
    align: "center",
    children: ['Copyright © ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      color: "inherit",
      href: "#",
      children: "That's The Ticket"
    }), ' ', new Date().getFullYear(), "."]
  });
}

/***/ }),

/***/ 5394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KF": function() { return /* binding */ acceptTicketbyToken; },
/* harmony export */   "VO": function() { return /* binding */ processMinAgeOverrideRequests; },
/* harmony export */   "XN": function() { return /* binding */ declineTicket; },
/* harmony export */   "Xp": function() { return /* binding */ declineTicketbyTokenOrId; },
/* harmony export */   "o9": function() { return /* binding */ acceptAllocationTicketByIdOrToken; },
/* harmony export */   "p3": function() { return /* binding */ acceptTicket; },
/* harmony export */   "qB": function() { return /* binding */ downloadTicket; },
/* harmony export */   "r3": function() { return /* binding */ processAccessibilityRequests; },
/* harmony export */   "rs": function() { return /* binding */ verifyUserAndTicketAccessibilityMatch; },
/* harmony export */   "zR": function() { return /* binding */ downloadAllocationTicket; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89092);
/* harmony import */ var src_models_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53901);




var verifyUserAndTicketAccessibilityMatch = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ticketid) {
    var response, url, message, res, resText;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "/api/backend/tickets/user-accessibility/".concat(ticketid);
            message = null;
            _context.prev = 2;
            _context.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 5:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 11;
              break;
            }

            _context.next = 9;
            return res.json();

          case 9:
            resText = _context.sent;
            throw new Error(resText.errors.message);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = 'Unable to determine accessibility match';
            }

          case 16:
            return _context.abrupt("return", {
              data: response,
              error: message
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13]]);
  }));

  return function verifyUserAndTicketAccessibilityMatch(_x) {
    return _ref.apply(this, arguments);
  };
}();
var acceptTicket = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(ticketid) {
    var fetchUrl, res, resText, response, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            fetchUrl = "/api/backend/tickets/accept/".concat(ticketid);
            _context2.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 4:
            res = _context2.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context2.next = 11;
              break;
            }

            _context2.next = 8;
            return res.text();

          case 8:
            resText = _context2.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context2.next = 13;
            return res.json();

          case 13:
            response = _context2.sent;
            return _context2.abrupt("return", {
              response: response.success
            });

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0 instanceof Error) {
              message = _context2.t0.message;
            } else {
              message = "Unable to load ticket";
            }

            return _context2.abrupt("return", {
              error: message
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 17]]);
  }));

  return function acceptTicket(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var acceptAllocationTicketByIdOrToken = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(tokenOrbookingInterestId, acceptedRelatedBookingInterestIds) {
    var response, message, res, fetchUrl, _fetchUrl, resText;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            message = null;
            _context3.prev = 1;

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context3.next = 9;
              break;
            }

            fetchUrl = "/api/backend/tickets/accept/".concat(tokenOrbookingInterestId);
            _context3.next = 6;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });

          case 6:
            res = _context3.sent;
            _context3.next = 13;
            break;

          case 9:
            _fetchUrl = "/api/backend/tickets/acceptAllocationTicketById/".concat(tokenOrbookingInterestId);
            _context3.next = 12;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(_fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(acceptedRelatedBookingInterestIds)
            });

          case 12:
            res = _context3.sent;

          case 13:
            if (!(res.status >= 400 && res.status < 600)) {
              _context3.next = 18;
              break;
            }

            _context3.next = 16;
            return res.json();

          case 16:
            resText = _context3.sent;
            throw new Error(resText.errors.message);

          case 18:
            _context3.next = 20;
            return res.json();

          case 20:
            response = _context3.sent;
            _context3.next = 26;
            break;

          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](1);

            if (_context3.t0 instanceof Error) {
              message = _context3.t0.message;
            } else {
              message = "Unable to load ticket";
            }

          case 26:
            return _context3.abrupt("return", {
              data: response,
              error: message
            });

          case 27:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 23]]);
  }));

  return function acceptAllocationTicketByIdOrToken(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
var declineTicket = /*#__PURE__*/function () {
  var _ref4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(ticketId) {
    var fetchUrl, res, resText, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            fetchUrl = "/api/backend/tickets/cancel/".concat(ticketId);
            _context4.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 4:
            res = _context4.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context4.next = 11;
              break;
            }

            _context4.next = 8;
            return res.text();

          case 8:
            resText = _context4.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context4.next = 13;
            return res.json();

          case 13:
            responseObject = _context4.sent;
            return _context4.abrupt("return", {
              response: responseObject
            });

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](0);

            if (_context4.t0 instanceof Error) {
              message = _context4.t0.message;
            } else {
              message = "Unable to decline ticket";
            }

            return _context4.abrupt("return", {
              error: message
            });

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 17]]);
  }));

  return function declineTicket(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
var declineTicketbyTokenOrId = /*#__PURE__*/function () {
  var _ref5 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(tokenOrbookingInterestId) {
    var res, fetchUrl, _fetchUrl2, resText, responseObject, message;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (!(typeof tokenOrbookingInterestId === 'string')) {
              _context5.next = 8;
              break;
            }

            fetchUrl = "/api/backend/tickets/cancel/".concat(tokenOrbookingInterestId);
            _context5.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 5:
            res = _context5.sent;
            _context5.next = 12;
            break;

          case 8:
            _fetchUrl2 = "/api/backend/tickets/cancelByBookingInterestId/".concat(tokenOrbookingInterestId);
            _context5.next = 11;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(_fetchUrl2, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 11:
            res = _context5.sent;

          case 12:
            if (!(res.status >= 400 && res.status < 600)) {
              _context5.next = 18;
              break;
            }

            _context5.next = 15;
            return res.text();

          case 15:
            resText = _context5.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 18:
            _context5.next = 20;
            return res.json();

          case 20:
            responseObject = _context5.sent;
            return _context5.abrupt("return", {
              response: responseObject
            });

          case 24:
            _context5.prev = 24;
            _context5.t0 = _context5["catch"](0);

            if (_context5.t0 instanceof Error) {
              message = _context5.t0.message;
            } else {
              message = "Unable to decline ticket";
            }

            return _context5.abrupt("return", {
              error: message
            });

          case 28:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 24]]);
  }));

  return function declineTicketbyTokenOrId(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
var acceptTicketbyToken = /*#__PURE__*/function () {
  var _ref6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(token) {
    var fetchUrl, res, resJson, response;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            fetchUrl = "/api/backend/tickets/accept/".concat(token);
            _context6.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 4:
            res = _context6.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context6.next = 10;
              break;
            }

            _context6.next = 8;
            return res.json();

          case 8:
            resJson = _context6.sent;
            throw new Error(resJson.errors.message);

          case 10:
            _context6.next = 12;
            return res.json();

          case 12:
            response = _context6.sent;
            return _context6.abrupt("return", {
              response: response
            });

          case 16:
            _context6.prev = 16;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", {
              error: _context6.t0
            });

          case 19:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 16]]);
  }));

  return function acceptTicketbyToken(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
var downloadTicket = /*#__PURE__*/function () {
  var _ref7 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(userEmail, ticketId) {
    var fetchUrl, res, resText, url, link, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            fetchUrl = "/api/backend/tickets/download?ticketId=".concat(ticketId, "&email=").concat(userEmail);
            _context7.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "GET",
              headers: {
                responseType: "blob"
              }
            });

          case 4:
            res = _context7.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context7.next = 11;
              break;
            }

            _context7.next = 8;
            return res.text();

          case 8:
            resText = _context7.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context7.t0 = URL;
            _context7.next = 14;
            return res.blob();

          case 14:
            _context7.t1 = _context7.sent;
            url = _context7.t0.createObjectURL.call(_context7.t0, _context7.t1);
            link = document.createElement("a");
            link.href = url;
            link.download = "ticket.pdf";
            link.click();
            _context7.next = 22;
            return res.json();

          case 22:
            responseObject = _context7.sent;
            return _context7.abrupt("return", {
              response: responseObject.success
            });

          case 26:
            _context7.prev = 26;
            _context7.t2 = _context7["catch"](0);

            if (_context7.t2 instanceof Error) {
              message = _context7.t2.message;
            } else {
              message = "Unable to download ticket";
            }

            return _context7.abrupt("return", {
              error: message
            });

          case 30:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 26]]);
  }));

  return function downloadTicket(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();
var downloadAllocationTicket = /*#__PURE__*/function () {
  var _ref8 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(bookingInterestToken) {
    var fetchUrl, res, resText, url, link, responseObject, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            fetchUrl = "/api/backend/tickets/download/".concat(bookingInterestToken);
            _context8.next = 4;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetch */ .zo)(fetchUrl, {
              method: "GET",
              headers: {
                responseType: "blob"
              }
            });

          case 4:
            res = _context8.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context8.next = 11;
              break;
            }

            _context8.next = 8;
            return res.text();

          case 8:
            resText = _context8.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 11:
            _context8.t0 = URL;
            _context8.next = 14;
            return res.blob();

          case 14:
            _context8.t1 = _context8.sent;
            url = _context8.t0.createObjectURL.call(_context8.t0, _context8.t1);
            link = document.createElement("a");
            link.href = url;
            link.download = "ticket.pdf";
            link.click();
            _context8.next = 22;
            return res.json();

          case 22:
            responseObject = _context8.sent;
            return _context8.abrupt("return", {
              response: responseObject.success
            });

          case 26:
            _context8.prev = 26;
            _context8.t2 = _context8["catch"](0);

            if (_context8.t2 instanceof Error) {
              message = _context8.t2.message;
            } else {
              message = "Unable to download ticket";
            }

            return _context8.abrupt("return", {
              error: message
            });

          case 30:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 26]]);
  }));

  return function downloadAllocationTicket(_x10) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * What the admin decided about a pending accessibility request.
 *  - Release: approve and hand the ticket over now, jumping the queue
 *  - Queue:   approve the need but leave them queued for the engine to serve in turn
 *  - Decline: refuse
 */

var processAccessibilityRequests = /*#__PURE__*/function () {
  var _ref9 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(bookingInterestId, isAccepted, decision) {
    var fetchUrl, requestBody, res, resText, response, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            fetchUrl = "/api/backend/tickets/process-accessibility-requests/".concat(bookingInterestId); // isAccepted is still sent: the endpoint falls back to it when decision is absent, so
            // the two stay consistent rather than the server having to guess between them.

            requestBody = JSON.stringify({
              bookingInterestId: bookingInterestId,
              isAccepted: isAccepted,
              decision: decision
            });
            _context9.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json"
              },
              body: requestBody
            });

          case 5:
            res = _context9.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context9.next = 12;
              break;
            }

            _context9.next = 9;
            return res.text();

          case 9:
            resText = _context9.sent;
            console.warn(resText);
            throw new Error("Server not returned a valid response");

          case 12:
            _context9.next = 14;
            return res.json();

          case 14:
            response = _context9.sent;
            return _context9.abrupt("return", {
              response: response.success
            });

          case 18:
            _context9.prev = 18;
            _context9.t0 = _context9["catch"](0);

            if (_context9.t0 instanceof Error) {
              message = _context9.t0.message;
            } else {
              message = "Unable to process accessibility requests";
            }

            return _context9.abrupt("return", {
              error: message
            });

          case 22:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 18]]);
  }));

  return function processAccessibilityRequests(_x11, _x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();
var processMinAgeOverrideRequests = /*#__PURE__*/function () {
  var _ref10 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(bookingInterestId, isAccepted) {
    var fetchUrl, requestBody, response, problemDetails, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            fetchUrl = "/api/backend/tickets/process-min-age-override-requests/".concat(bookingInterestId);
            requestBody = JSON.stringify({
              bookingInterestId: bookingInterestId,
              isAccepted: isAccepted
            });
            _context10.next = 5;
            return (0,_utils_auth__WEBPACK_IMPORTED_MODULE_1__/* .fetchWithAuth */ .ri)(fetchUrl, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json"
              },
              body: requestBody
            });

          case 5:
            response = _context10.sent;

            if (!(response.status === 400)) {
              _context10.next = 12;
              break;
            }

            _context10.next = 9;
            return response.json();

          case 9:
            problemDetails = _context10.sent;
            console.warn(problemDetails);
            return _context10.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MinAgeOverrideResponse */ .LB({
              error: problemDetails
            }));

          case 12:
            return _context10.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MinAgeOverrideResponse */ .LB({
              data: true
            }));

          case 15:
            _context10.prev = 15;
            _context10.t0 = _context10["catch"](0);

            if (_context10.t0 instanceof Error) {
              message = _context10.t0.message;
            } else {
              message = "Unable to process min age override requests";
            }

            return _context10.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_2__/* .MinAgeOverrideResponse */ .LB({
              error: message
            }));

          case 19:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 15]]);
  }));

  return function processMinAgeOverrideRequests(_x14, _x15) {
    return _ref10.apply(this, arguments);
  };
}();

/***/ })

}]);